import React from 'react';
import "./EmptyTableDataInfographic.css"

const EmptyTableDataInfographic = ({label="No data available", ...rest}) => {
    return (
        <div {...rest} className={"table-no-data"}>{label}</div>
    );
};

export default EmptyTableDataInfographic;